'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const initialState = ImmutableMap({
  categories: ImmutableSet(),
  hasError: false,
  isRequesting: false,
  lastValidResult: false,
  products: ImmutableSet(),
  recentError: undefined,
  topics: ImmutableSet(),
  subCategories: ImmutableSet(),
  hsSoftwareFilters: ImmutableSet(),
  levelFilters: ImmutableSet()
});
export default function Filters(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FILTERS_REQUESTING:
      {
        return state.merge({
          hasError: false,
          isRequesting: true
        });
      }
    case ActionTypes.FILTERS_RECEIVED:
      {
        return state.merge({
          isRequesting: false,
          lastValidResult: Date.now(),
          hasError: false,
          categories: action.payload.categories,
          products: action.payload.products,
          topics: action.payload.topics,
          subCategories: action.payload.subCategories,
          hsSoftwareFilters: action.payload.hsSoftwareFilters,
          levelFilters: action.payload.levelFilters
        });
      }
    case ActionTypes.FILTERS_ERROR:
      {
        return state.merge({
          hasError: true,
          recentError: action.payload,
          isRequesting: false
        });
      }
    default:
      return state;
  }
}